/**
 * Top-bar zoom and hand-mode controls.
 */
export function initZoomPanControls(options = {}, documentRef = document) {
  const resetZoom =
    options.resetZoom || (() => window.resetZoom && window.resetZoom())
  const zoomByButton =
    options.zoomByButton ||
    (scale => window.zoomByButton && window.zoomByButton(scale))

  documentRef.addEventListener('contextmenu', event => event.preventDefault())

  const resetBtn = documentRef.getElementById('resetZoomBtn')
  const zoomInBtn = documentRef.getElementById('zoomInBtn')
  const zoomOutBtn = documentRef.getElementById('zoomOutBtn')
  const panBtn = documentRef.getElementById('panModeBtn')
  const svgElem = documentRef.getElementById('mySvg')

  if (resetBtn) resetBtn.addEventListener('click', resetZoom)
  if (zoomInBtn) zoomInBtn.addEventListener('click', () => zoomByButton(1.1))
  if (zoomOutBtn)
    zoomOutBtn.addEventListener('click', () => zoomByButton(1 / 1.1))

  window._panMode = false
  function updatePanCursor() {
    if (!panBtn || !svgElem) return
    if (window._panMode) {
      svgElem.style.cursor = 'grab'
      panBtn.textContent = 'Hand: On'
    } else {
      svgElem.style.cursor = 'default'
      panBtn.textContent = 'Hand: Off'
    }
  }

  if (panBtn) {
    panBtn.addEventListener('click', () => {
      window._panMode = !window._panMode
      updatePanCursor()
    })
  }
  updatePanCursor()
}
